import { render } from "./RepoList.vue?vue&type=template&id=13ce0fc1&ts=true"
import script from "./RepoList.vue?vue&type=script&lang=ts"
export * from "./RepoList.vue?vue&type=script&lang=ts"

import exportComponent from "/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__